export const filterData: any[] = [
  {
    collapseHeaderTitle: "Chains",
    checkboxes: [
      {
        checkboxTitle: "Ethereum",
      },
      {
        checkboxTitle: "Polygon",
      },
      {
        checkboxTitle: "Klaytn",
      },
    ],
  },
  {
    collapseHeaderTitle: "On Sales in",
    checkboxes: [
      {
        checkboxTitle: "ETH",
      },
      {
        checkboxTitle: "WETH",
      },
    ],
  },
  {
    collapseHeaderTitle: "Body",
    checkboxes: [
      {
        checkboxTitle: "Full",
      },
      {
        checkboxTitle: "Potrait",
      },
    ],
  },
  {
    collapseHeaderTitle: "Clothing",
    checkboxes: [
      {
        checkboxTitle: "Full",
      },
      {
        checkboxTitle: "Potrait",
      },
    ],
  },
  {
    collapseHeaderTitle: "Clothing",
    checkboxes: [
      {
        checkboxTitle: "Full",
      },
      {
        checkboxTitle: "Potrait",
      },
    ],
  },
  {
    collapseHeaderTitle: "Collection",
    checkboxes: [
      {
        checkboxTitle: "NOn",
        checkboxCount: 4,
      },
    ],
  },
  {
    collapseHeaderTitle: "Champion",
    checkboxes: [
      {
        checkboxTitle: "Cat",
        checkboxCount: 4,
      },
    ],
  },
  {
    collapseHeaderTitle: "Element",
    checkboxes: [
      {
        checkboxTitle: "Choas",
        checkboxCount: 4,
      },
      {
        checkboxTitle: "Feathers",
        checkboxCount: 4,
      },
    ],
  },
  {
    collapseHeaderTitle: "FaceWear",
    checkboxes: [
      {
        checkboxTitle: "Choas",
        checkboxCount: 4,
      },
      {
        checkboxTitle: "Feathers",
        checkboxCount: 4,
      },
    ],
  },
  {
    collapseHeaderTitle: "Footwear",
    checkboxes: [
      {
        checkboxTitle: "Choas",
        checkboxCount: 2,
      },
      {
        checkboxTitle: "Feathers",
        checkboxCount: 2,
      },
    ],
  },
  {
    collapseHeaderTitle: "Hair Color",
    checkboxes: [
      {
        checkboxTitle: "Choas",
        checkboxCount: 4,
      },
      {
        checkboxTitle: "Feathers",
        checkboxCount: 4,
      },
    ],
  },
  {
    collapseHeaderTitle: "Hair Color",
    checkboxes: [
      {
        checkboxTitle: "Choas",
        checkboxCount: 4,
      },
      {
        checkboxTitle: "Feathers",
        checkboxCount: 4,
      },
    ],
  },
  {
    collapseHeaderTitle: "Hair Jwelery",
    checkboxes: [
      {
        checkboxTitle: "Choas",
        checkboxCount: 4,
      },
      {
        checkboxTitle: "Feathers",
        checkboxCount: 4,
      },
    ],
  },
  {
    collapseHeaderTitle: "Hair",
    checkboxes: [
      {
        checkboxTitle: "Choas",
        checkboxCount: 4,
      },
      {
        checkboxTitle: "Feathers",
        checkboxCount: 4,
      },
    ],
  },
  {
    collapseHeaderTitle: "Hands",
    checkboxes: [
      {
        checkboxTitle: "Choas",
        checkboxCount: 4,
      },
      {
        checkboxTitle: "Feathers",
        checkboxCount: 4,
      },
    ],
  },
  {
    collapseHeaderTitle: "Lips",
    checkboxes: [
      {
        checkboxTitle: "Choas",
        checkboxCount: 4,
      },
      {
        checkboxTitle: "Feathers",
        checkboxCount: 4,
      },
    ],
  },
  {
    collapseHeaderTitle: "Location",
    checkboxes: [
      {
        checkboxTitle: "Choas",
        checkboxCount: 4,
      },
      {
        checkboxTitle: "Feathers",
        checkboxCount: 4,
      },
    ],
  },
  {
    collapseHeaderTitle: "Tea",
    checkboxes: [
      {
        checkboxTitle: "Choas",
        checkboxCount: 4,
      },
      {
        checkboxTitle: "Tea accent",
        checkboxCount: 4,
      },
    ],
  },
];

export const filterDataCollection: any[] = [
  {
    collapseHeaderTitle: "Chains",
    checkboxes: [
      {
        checkboxTitle: "Ethereum",
      },
      {
        checkboxTitle: "Polygon",
      }
    ],
  }
];
